import * as _ from "lodash";

export class Assignment {
    public id: string | null = null;
    public assignmentname: string | null = null;
    public users: any[] = [];
    public teams: any[] = [];
    public start: any;
    public end: any;
    public starttimestamp: string;
    public endtimestamp: string;
    public status: string = "Active";
    private modelsUtils: any;
    constructor(ModelsUtils: any, data?: object) {
        this.modelsUtils = ModelsUtils;

        if (data) {
            this.setData(data);
        }
    }

    setData(data: any): void {
        if (data.starttimestamp) {
            // Safari fix
            data.start = {
                date: new Date(data.starttimestamp.replace(/-/g, "/")),
            };
        } else {
            const d = new Date(); // copy so we don't mutate input
            const minutes = d.getMinutes();
            const next = Math.ceil(minutes / 15) * 15;

            d.setMinutes(next);
            d.setSeconds(0);
            d.setMilliseconds(0);
            data.start = {
                date: d,
            };
        }
        this.populateHours(data.start);

        if (data.endtimestamp) {
            data.end = {
                date: new Date(data.endtimestamp.replace(/-/g, "/")),
            };
            this.populateHours(data.end);
        }
        if (data.teams) {
            this.teams = [];
            for (let i = 0; i < data.teams.length; i++) {
                this.teams.push(this.modelsUtils.team(data.teams[i]));
            }
        }

        if (data.users) {
            this.users = [];
            for (let i = 0; i < data.users.length; i++) {
                this.users.push(this.modelsUtils.user(data.users[i]));
            }
        }
        _.merge(this, data);
    }
    private is24hr(): boolean {
        return document.cookie.split("; ").some((c) => c === "24hrTime=1");
    }

    populateHours(date?: any): void {
        if (date && !date.time) {
            let hours = date.date.getHours();
            let minutes =
                (date.date.getMinutes() < 10 ? "0" : "") +
                date.date.getMinutes();

            if (this.is24hr()) {
                let h = hours < 10 ? "0" + hours : hours.toString();
                date.time = {
                    hours: hours,
                    minutes: minutes,
                    period: "",
                    model: h + ":" + minutes,
                };
            } else {
                let period = "am";

                if (hours >= 12) {
                    hours -= 12;
                    period = "pm";
                }

                let modelHours = hours === 0 ? 12 : hours;
                let model = modelHours + ":" + minutes + period;

                date.time = {
                    hours: hours,
                    minutes: minutes,
                    period: period,
                    model: model,
                };
            }
        }
    }
    assigneesString(): string {
        return this.users
            .map((u: any): string => `${u.ufname} ${u.ulname}`)
            .concat(this.teams.map((t: any): string => t.tname))
            .join(", ");
    }
    assignees(): any {
        return this.users.concat(this.teams);
    }
}
